import { addDoc, updateDoc } from 'firebase/firestore'

import AFirestore from './AFirestore'
import { IDatabaseWrite } from './IDatabaseWrite'

class WriteFirestore extends AFirestore implements IDatabaseWrite {
  /**
   * Update document entries with a given object
   * @param value - object entries to update
   * @returns
   */
  update(value: object): Promise<void> {
    return updateDoc(this.getDocument(), value)
  }
  /**
   * Create a new document in collection with given object
   * @param value
   * @returns
   */
  create(value: object) {
    return addDoc(this.getCollection(), value)
  }
}

export default WriteFirestore
